import { useMemo } from 'react';
// Timezone aliases to handle timezone name inconsistencies
const TIMEZONE_ALIASES = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Pacific': 'America/Los_Angeles',
};

export const useTimezones = () => {
  return useMemo(() => {
    if (typeof Intl.supportedValuesOf !== 'function') {
      return [];
    }
    const timezones = Intl.supportedValuesOf('timeZone')
      .map((tz) => ({
        label: TIMEZONE_ALIASES[tz] || tz,
        value: TIMEZONE_ALIASES[tz] || tz,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    return timezones;
  }, []);
};
